import React from 'react';
import './Background.css';
import {
  HashRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";



export function Background() {
  return (
    <div >
      
        <div class="background">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
        

      
    </div>
  );
}


